export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7657.690ccd4c.jpg";